import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { LibraryChatScreen } from '@/components/libraryChat/LibraryChatScreen';

/** A new conversation. Its id is made here and exists on the server only once a first turn is accepted. */
export default function NewAskConversationRoute() {
  const [conversationId] = useState(() => uuidv4());

  return <LibraryChatScreen conversationId={conversationId} isNew />;
}
